module.exports = __webpack_public_path__ + "img/box-right-4.af8cd2dd.png";